export default __webpack_public_path__ + "static/WhatsApp-f69eed123170fcec1328e7c4c92b1265.svg";